module.exports = __webpack_public_path__ + "img/icons BFr_33.c2e47d24.svg";